import React, { useState } from 'react'
import { View, Text, StyleSheet } from '~/ui/primitives'
import Slider from "~/ui/slider"
import { useTheme } from '~/ui/styled'

interface Props {
  min?: number
  max?: number
  step?: number
  value?: number
  onChange?: (val: number) => void
}

export default function SlideInput({
  min = 0,
  max = 100,
  step = 1,
  value = 0,
  onChange,
}: Props) {
    const theme = useTheme()
  const [val, setVal] = useState(value)

  const handleChange = (v: number) => {
    setVal(v)
    onChange?.(v)
  }

  return (
    <View style={styles.container}>

      <Slider
        style={{ width: '80%' }}
        minimumValue={min}
        maximumValue={max}
        step={step}
        value={val}
        onValueChange={handleChange}
        minimumTrackTintColor={theme.colors.primary}
        maximumTrackTintColor="#e5e6eb"
        thumbTintColor={theme.colors.primary}
      />
      <Text style={styles.value}>{val}%</Text>

    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 8,
    width: '100%',
    display: 'flex',
    flexDirection:"row",
    justifyContent:"flex-start",
    alignItems:"center",
  },
  value: {
    textAlign: 'left',
    fontSize: 16,
    marginLeft: 8,
    width: '20%',
  }
})
